import type { CSSProperties, JSX } from 'react';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';
import { hexWithAlpha } from '../../../../_theme/palette.js';

interface SectionFieldProps {
  palette: Palette;
  question: SurveyQuestion;
}

export function SectionField({ palette, question }: SectionFieldProps): JSX.Element {
  const description = question.description ?? '';
  return (
    <div style={wrapperStyle(palette)}>
      <div style={{ fontSize: 13, fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase', color: palette.primary }}>
        Section
      </div>
      <div style={{ fontSize: 18, fontWeight: 600, color: palette.text }}>{question.label}</div>
      {description && (
        <div style={{ fontSize: 14, lineHeight: 1.5, color: palette.textMuted }}>{description}</div>
      )}
    </div>
  );
}

function wrapperStyle(palette: Palette): CSSProperties {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    padding: '14px 16px',
    borderRadius: 12,
    border: `1px solid ${hexWithAlpha(palette.textMuted, 0.18)}`,
    background: hexWithAlpha(palette.primary, 0.04),
  };
}
